import { forwardRef } from 'react';
import { DbStore } from '@/hooks/useData';
import { Star, ShieldCheck } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';

interface StoreCardProps {
  store: DbStore;
}

const StoreCard = forwardRef<HTMLDivElement, StoreCardProps>(({ store }, ref) => {
  const navigate = useNavigate();

  return (
    <motion.div
      ref={ref}
      whileHover={{ y: -3 }}
      whileTap={{ scale: 0.96 }}
      onClick={() => navigate(`/store/${store.id}`)}
      className="flex-shrink-0 w-[115px] cursor-pointer group"
    >
      <div className="relative w-[72px] h-[72px] mx-auto rounded-2xl bg-card border-2 border-border/50 flex items-center justify-center overflow-hidden premium-shadow group-hover:border-primary/30 group-hover:premium-shadow-hover transition-all duration-400">
        {store.logo_url ? (
          <img src={store.logo_url} alt={store.name} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" />
        ) : (
          <span className="text-3xl">🏪</span>
        )}
        {store.is_verified && (
          <div className="absolute -bottom-0.5 -end-0.5 w-5 h-5 rounded-full gradient-primary flex items-center justify-center border-2 border-card shadow-sm">
            <ShieldCheck size={10} className="text-primary-foreground" />
          </div>
        )}
      </div>
      <div className="text-center mt-2">
        <h3 className="text-[11px] font-bold truncate px-1 group-hover:text-primary transition-colors">{store.name}</h3>
        <div className="flex items-center justify-center gap-0.5 mt-0.5">
          <Star size={10} className="fill-warning text-warning" />
          <span className="text-[10px] text-muted-foreground font-semibold">{store.rating || '0'}</span>
        </div>
      </div>
    </motion.div>
  );
});

StoreCard.displayName = 'StoreCard';

export default StoreCard;
